module.exports = "/img/29.f48ce1.webp";